/**
 * Fonte única dos cookies do app: nomes e TTLs. Compartilhado entre o BFF
 * (route handlers / proxy, server-side) e os helpers de browser/cliente.
 *
 * Access e refresh são custodiados pelo servidor (httpOnly); session e loja
 * selecionada são legíveis pelo cliente. Ver `app/api/auth/_cookies.ts` para
 * as opções de escrita server-side.
 */

// httpOnly (servidor)
export const ACCESS_COOKIE = "access_token";
export const REFRESH_COOKIE = "refresh_token";
// legíveis pelo cliente
export const USER_COOKIE = "auth_user";
export const SESSION_COOKIE = "x-session-id";
export const SELECTED_STORE_COOKIE = "selected_store";

/**
 * Parâmetro de URL que escolhe a loja (`?loja=<id>`): o proxy o converte no
 * cookie acima. Usado nos links do feed de produtos e em links de campanha.
 */
export const STORE_URL_PARAM = "loja";

const DAY = 60 * 60 * 24;

/** TTLs em segundos. `access` acompanha JWT_EXPIRES_IN; `refresh` o JWT_REFRESH_EXPIRES_IN. */
export const COOKIE_MAX_AGE = {
    access: 60 * 15, // 15 min
    refresh: DAY * 7, // 7 dias (também usado pelo cookie de identidade)
    year: DAY * 365, // 1 ano (sessão de convidado e loja selecionada)
} as const;
